module.exports = __webpack_public_path__ + "static/media/linked-in.76f2376b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/Footer/linked-in.svg
// module id = 257
// module chunks = 0